export const environment = {
    production: true,
    appPrefix: "app_cpd_analytics_dev_",
    baseHref: "/",
    administratorPrefix: "administrator",
    locale: {
        default: "vi",
        list: ['vi', 'en'],
        version: "20220629200022",
    },
    google: {
        clientVerify: true,
        recaptchaV3: {
            siteKey: '6Ld4TIIrAAAAAEVWynRIF9pR5HGTU9uIm6e8Bf6B'
        }
    },
    rsa: {
        isActive: true,
        server: {
            publicKeyEncode: 'LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlJQklqQU5CZ2txaGtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUE2OUJVMFZGSGExVVM3MjhCVFJsVgpybW93WStPTTJsbk9HSFNTQnBUYW5kamFXNGNhcXdKODA0ZUwwTExIV1lqRFRYUXZ6U241YmVrU1cwVEFsZEsxClhiekZpTVdpRyt1MjZreUVrbTBETmt4TTFaTUNJN2JoWktqQ0UwTU4rVWVDTVFWTXdkcjdJZU5kQ3NzSTBsdWcKbDhzRzBXY1E4T2JzcGt2YmZUcFJWcmUrSzhrOGsrM3VabVhEVVB2OUpVZzAvUmdqRUsyZnQrcE1VNE56Z0pIWQo3TkpCSjZMUTdxVHRMSTUveXZCcW43Ry9GbnpSWUpmVWpKUjVnNHRPSjAzRFIrWGhuL3RkUlUyQUFReHRBcUhkCjd6RHM1SVd2V3lyZksyVDh5eDBDZXdVQnAzNk5saTJSQlhtMnF4NW1ObWF4ZjFwK2hmUTF2R1lsNlYxSkJGTXkKb1FJREFRQUIKLS0tLS1FTkQgUFVCTElDIEtFWS0tLS0t'
        }
    },
    roles: {
        superAdmin: 1,
        admin: 2,
        user: 3
    },
    admicroSso: {
        termOfService: 'https://adx.admicro.vn/vn/tos',
        register: 'https://sso.admicro.vn/signup',
        linkForgotPassword: 'https://sso.admicro.vn/password/lost',
    },
    analytics: {
        booking: {
            inventoryBookingLocation: 'https://inventory-trading.admicro.vn/booking/calendar/location/overview'
        }
    },
    backendServer: {
        host: 'dev.cpd-analytics.admicro.vn',
        port: 443,
        ssl: true,
        prefix: '/api/v1/',
        url: 'https://dev.cpd-analytics.admicro.vn',
        paths: {
            auth: {
                login: 'admicro/auth/login',
                logout: 'auth/logout'
            },
            core: {
                settings: {
                    get: 'core/settings/get'
                }
            }
        }
    }
};
